import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { addReqiredMessage } from '@/components/slides/DataSummary/util/addRequiredMessage.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { useForm } from '@/form/useForm.ts';

export const NameSummaryFormGB = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({ slideIds: ['name'] });

  const { getFieldValue } = useForm();

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;

  const firstNameField = addReqiredMessage({
    field: s.name.fields.find(({ name }) => name === 'firstname'),
    message: s.dataSummary.requiredMessage!,
  });
  const firstNameLabel = translate(firstNameField?.label);

  const genderField = s.name.fields.find(({ name }) => name === 'gender');
  const genderLabel = translate(genderField?.label);

  const middleNameField = s.name.fields.find(({ name }) => name === 'middlename');
  const middleNameLabel = translate(middleNameField?.label);

  const lastNameField = addReqiredMessage({
    field: s.name.fields.find(({ name }) => name === 'lastname'),
    message: s.dataSummary.requiredMessage!,
  });
  const lastNameLabel = translate(lastNameField?.label);

  const titleField = s.name.fields.find(({ name }) => name === 'title');
  const titleLabel = translate(titleField?.label);
  const titleValue =
    translate(titleField?.options?.find(({ value }) => value === getFieldValue('title'))?.label) ||
    getFieldValue('title');

  return (
    <div className="summary-card" data-cy={'summary-form-name'}>
      <h2>{translate(s.dataSummary.titles?.name)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />

      <div className="data">
        <div className={'label'}>{titleLabel}</div>
        <div className={'value'}>
          {!editMode && titleValue}
          {editMode && <EditDataField field={titleField!} slideId={'name'} />}
        </div>

        <div className={'label'}>{genderLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('gender')}
          {editMode && <EditDataField field={genderField!} slideId={'name'} />}
        </div>

        <div className={'label'}>{firstNameLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('firstname')}
          {editMode && <EditDataField field={firstNameField!} slideId={'name'} />}
        </div>

        <div className={'label'}>{middleNameLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('middlename')}
          {editMode && <EditDataField field={middleNameField!} slideId={'name'} />}
        </div>

        <div className={'label'}>{lastNameLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('lastname')}
          {editMode && <EditDataField field={lastNameField!} slideId={'name'} />}
        </div>
      </div>
    </div>
  );
};
